// extracted by mini-css-extract-plugin
export default {"block":"CFsuta","block__linkRow":"sbTs99"};